export default "__VITE_ASSET__buUlstWZXmijowLzwsQ9tw__"